import React from "react";

// Declare the global rnw function from release-notes-widget
declare global {
  function rnw(command: string): void;
  namespace JSX {
    interface IntrinsicElements {
      "rn-banner": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & {
          type?: string;
          "background-color"?: string;
          "button-text"?: string;
          "border-radius"?: string;
          "font-family"?: string;
          margin?: string;
          prefix?: string;
          "prefix-background-color"?: string;
          shadow?: string;
        },
        HTMLElement
      >;
    }
  }
}

export const showReleaseNotesBanner = () => {
  rnw("show");
};

export const ReleaseNotesBanner = () => {
  return (
    <rn-banner
      type="feature"
      background-color="#1F72E3"
      button-text="Learn More"
      border-radius="0"
      font-family="Mulish"
      margin="0"
      prefix="Latest Release"
      prefix-background-color="#FF8400"
      shadow="none"
    ></rn-banner>
  );
};
